<template>
  <div>
    <Loading
      :show="isScreenLoading"
    />
    <div class="entry-contents-ttl container-xl text-center">
      <h2>サービスアカウント作成</h2>
    </div>

    <div class="container-xl">
      <div class="row row-flow">
        <div class="col-3">
          <div class="flow-item rounded-start current">メールアドレス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item current">ワンタイムパス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item current">必要事項<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">完了</div>
        </div>
      </div>
    </div>

    <!-- フォームアイテム --------------------------- -->
    <form @submit.prevent="validate" novalidate>
      <main class="container-xl">
        <div class="primary-area">
          <section class="primary-section">
          <!-- セクションタイトル --------------------------- -->
            <div class="section-ttl">
              <h3>サービスアカウント情報</h3>
              <div class="small">
                サービスアカウントは、設備を監視するために必要な情報を管理するアカウントです。
                監視デバイスや監視ユーザーの登録、お支払い情報の監理などを行います。
              </div>
            </div>

          <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  アカウント名（組織名など）<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="例）野原製作所"
                  required
                  class="form-control"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg('name'),
                  }"
                  v-model="formData.organization.name"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('name') }}
                </div>
              </dd>
            </dl>
          </section>

          <section class="primary-section">
          <!-- セクションタイトル --------------------------- -->
            <div class="section-ttl">
              <h3>契約ユーザー情報</h3>
              <div class="small">
                契約ユーザーとは、サービスアカウントのすべての設定を閲覧、編集できるユーザーです。
                サービスアカウントを新規で作成したユーザーは、自動的にサービスアカウント契約ユーザーとなります。
              </div>
            </div>

          <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  ユーザー名<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="例）野原 太郎"
                  required
                  class="form-control"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg('ownerUserName'),
                  }"
                  autocomplete="none"
                  v-model="formData.organization.ownerUserName"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('ownerUserName') }}
                </div>
              </dd>
            </dl>

          <!-- input なし --------------------------- -->
            <dl class="section-item row single-item">
              <dt class="col-md-3">
                メールアドレス<div class="ico-txt required">必須</div>
              </dt>
              <dd class="col-md-9">
                {{ formData.organization.ownerUserEmail }}
              </dd>
            </dl>

          <!-- input password --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  パスワード<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  type="password"
                  placeholder="8文字以上の大文字、小文字、数字で構成される半角英数字"
                  required
                  class="form-control"
                  :class="{
                    'form-error': formErrors.organization.getErrorMsg('password'),
                  }"
                  autocomplete="none"
                  v-model="formData.password1"
                />
                <Input
                  type="password"
                  placeholder="確認のため、もう一度入力してください"
                  required
                  class="form-control mt-2"
                  :class="{
                    'form-error': formErrors.organization.getErrorMsg('password'),
                  }"
                  v-model="formData.password2"
                />
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('password') }}
                </div>
              </dd>
            </dl>
          </section>

          <section class="primary-section">
            <div class="section-ttl">
              <h3>お支払い情報</h3>
              <div class="small">お支払い情報は、サービスアカウントの作成後、「監視デバイス」の登録によりサービス利用料金が発生した場合に利用します。</div>
            </div>

          <!-- input radio --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  お支払いタイプ
                </label>
              </dt>
              <dd class="col-md-9 row">
                <div class="form-check-inline col-md-4">
                  <input
                    class="form-check-input"
                    type="radio"
                    checked
                  >
                  <label class="form-check-label" for="cstm-radio-02">
                    銀行振込
                  </label>
                </div>
                <div class="small notes">※ 銀行振込の場合、監視デバイスの登録日の翌月末までにお振り込みください。</div>
              </dd>
            </dl>
          </section>

          <section class="primary-section">
            <div class="section-ttl">
              <h3>ご請求情報</h3>
              <div class="small">ご請求情報は、請求書・領収書の発行に利用します。</div>
            </div>

            <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  社名<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="例）ノバルス株式会社"
                  required
                  class="form-control"
                  :class="{
                    'form-error':
                      formErrors.organization.getErrorMsg('billingAddressCompanyName'),
                  }"
                  v-model="formData.organization.billingAddress.companyName"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressCompanyName') }}
                </div>
              </dd>
            </dl>

            <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  住所<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="郵便番号"
                  required
                  class="form-control form-s"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressPostalCode',
                    ),
                  }"
                  @change="postalCodeOnChange"
                  v-model="formData.organization.billingAddress.postalCode"
                />
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressPostalCode') }}
                </div>
                <Select
                  name="states"
                  :options="states"
                  :value="formData.organization.billingAddress.state"
                  placeholder="都道府県"
                  class="form-select form-s mt-2"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressState',
                    ),
                  }"
                  @update="formData.organization.billingAddress.state=$event"
                />
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressState') }}
                </div>
                <Input
                  placeholder="市区町村"
                  required
                  class="form-control mt-2"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressTown',
                    ),
                  }"
                  v-model="formData.organization.billingAddress.town"
                />
                <div class="small notes">
                  ※ 10文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressTown') }}
                </div>
                <Input
                  placeholder="番地"
                  required
                  class="form-control mt-2"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressStreet',
                    ),
                  }"
                  v-model="formData.organization.billingAddress.street"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressStreet') }}
                </div>
                <Input
                  placeholder="ビル・建物名"
                  class="form-control mt-2"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressBuilding',
                    ),
                  }"
                  v-model="formData.organization.billingAddress.building"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressBuilding') }}
                </div>
              </dd>
            </dl>

            <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  ご担当者名<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="例）ノバルス太郎"
                  required
                  class="form-control"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressPersonInChargeName',
                    ),
                  }"
                  v-model="formData.organization.billingAddress.personInChargeName"
                />
                <div class="small notes">
                  ※ 20文字以内で入力ください。
                </div>
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg(
                        'billingAddressPersonInChargeName',
                      )
                  }}
                </div>
              </dd>
            </dl>

            <!-- input text --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  ご連絡先電話番号<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  placeholder="例） 090-1234-5678"
                  required
                  class="form-control"
                  :class="{
                    'form-error': this.formErrors.organization.getErrorMsg(
                      'billingAddressPhoneNumber',
                    ),
                  }"
                  v-model="formData.organization.billingAddress.phoneNumber"
                />
                <div class="small notes notes-error">
                  {{  this.formErrors.organization.getErrorMsg('billingAddressPhoneNumber') }}
                </div>
              </dd>
            </dl>
          </section>

          <!-- ボタン --------------------------- -->
          <section class="primary-section">
            <div class="btn-area">
              <p>
                <a href="#" class="link-blue" @click.prevent="openTermsOfService">サービス利用規約</a>、
                <a href="#" class="link-blue" @click.prevent="openPrivacyPolicy">プライバシーポリシー</a>
                をお読みいただき同意のうえ、 <br class="pc">サービスを開始して下さい。
              </p>
              <div class="form-check check-l flex">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="formData.confirm"
                  @change="changeConfirmStatus"
                >
                <label class="form-check-label" for="cstm-check-03">同意する</label>
              </div>
              <Button
                :disabled="!isSubmitBtnActive"
              >作成する</Button>
            </div>
          </section>
        </div><!-- end .primary-area-->

        <CancelBrowserBackModal
          modalId="cancel-browser-back-modal"
          ref="cancelBrowserBackModal"
        />

      </main>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
/* システム共通 */
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

/* 画面固有 */
import {
  Organization,
} from "models/organization";
import {
  OrganizationSignUpValidator,
} from "validators/organizations";

import {
// Icon,
// Tooltip,
  Loading,
  Button,
  Input,
  Select,
  CancelBrowserBackModal,
} from "components";

import {
  TipIcon,
} from "icons";

import prefectures from "@/assets/js/prefectures";

const SignUpRepository = RepositoryFactory.get("sign-up");
const PostcodeJpRepository = RepositoryFactory.get("postcode-jp");

export default {
  name: "SingUpForm",
  components: {
    Loading,
    Input,
    Select,
    // Icon,
    // Tooltip,
    Button,
    CancelBrowserBackModal,
  },
  data() {
    return {
      icons: {
        TipIcon,
      },
      states: [],
      formData: {
        organization: new Organization(),
        password1: "",
        password2: "",
        confirm: false,
        openPrivacyPolicy: false,
        openTermsOfService: false,
      },
      formErrors: {
        organization: new OrganizationSignUpValidator(),
        password: "",
        confirm: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
      /* 画面固有 */
      signUpEmailVarification: "email-verification/signUpEmailVarification",
    }),
    isSubmitBtnActive() {
      return this.formData.confirm
        && this.formData.openPrivacyPolicy
        && this.formData.openTermsOfService
        && this.isScreenActive;
    },
  },
  async created() {
    // サインアップ用のメール認証情報が存在しなければ、メール入力画面に戻る（主にリロード対策）
    if (!this.signUpEmailVarification) {
      this.$router.push({ name: "SignUpSendAuthCode" });
    } else {
      this.states = prefectures.map((v) => v.prefName);

      // TODO: メールアドレスの取得
      if (this.signUpEmailVarification) {
        this.formData.organization.ownerUserEmail = this.signUpEmailVarification.email;
      } else {
        this.formData.organization.ownerUserEmail = "dummy@novars.jp";
      }
    }
  },
  mounted() {
    window.history.pushState(null, null, null);
    window.addEventListener("popstate", this.handlePopstate);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.handlePopstate);
  },
  methods: {
    handlePopstate() {
      window.history.pushState(null, null, null);
      this.$refs.cancelBrowserBackModal.openModal();
    },
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
      /* 画面固有 */
      signUpEmailVerificationEnd: "email-verification/signUpEmailVerificationEnd",
      updateSignUpNotificationFlag: "application/updateSignUpNotificationFlag",
    }),
    async changeConfirmStatus() {
      if (this.formData.confirm) {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      } else {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.INITIALIZE);
      }
    },
    async validate() {
      try {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        await this.resetNotification();

        // バリデーション
        this.formErrors.organization = OrganizationSignUpValidator.validate(
          this.formData.organization,
          this.formData.password1,
          this.formData.password2,
        );

        if (!this.formErrors.organization.result) {
          this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.submit();
        }
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async submit() {
      try {
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.LOADING);

        await SignUpRepository.signUp(
          this.formData.organization,
          this.formData.password1,
        );
        await this.updateSignUpNotificationFlag(true);
        this.$router.push({ name: "SignInForm" });
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async openPrivacyPolicy() {
      window.open("https://novars.jp/siteinfo/privacy/", "_blank");
      this.formData.openPrivacyPolicy = true;
    },
    async openTermsOfService() {
      window.open("https://mimamori.novars.jp/s/terms_of_service.html", "_blank");
      this.formData.openTermsOfService = true;
    },
    async postalCodeOnChange() {
      let { postalCode } = this.formData.organization.billingAddress;
      // フォーマット
      if (postalCode && postalCode.match(/^[0-9]{3}-?[0-9]{4}$/)) {
        try {
          postalCode = postalCode.replace("-", "");
          const items = await PostcodeJpRepository.postalCodeToAddress(postalCode);
          if (items.length > 0) {
            this.formData.organization.billingAddress.state = items[0].pref;
            this.formData.organization.billingAddress.town = items[0].city;
            this.formData.organization.billingAddress.street = items[0].town;
          }
        } catch (err) {
          // Note. グローバルエラーで、まとめて監視する？
          console.log(err);
        }
      }
    },
  },
};
</script>
